import { FeatureEntitlementName } from '@jupiterone/entitlement-types';
import gql from 'graphql-tag';
import { createUseMutationHook } from '../apollo/createUseMutationHook';

export const StartTrialForFeatureEntitlement = gql`
  mutation startFeatureEntitlementTrial(
    $featureEntitlementName: FeatureEntitlementName!
  ) {
    startFeatureEntitlementTrial(
      featureEntitlementName: $featureEntitlementName
    ) {
      resultCode
      message
    }
  }
`;

type Variables = {
  featureEntitlementName: FeatureEntitlementName;
};
type Response = {
  startFeatureEntitlementTrial: {
    resultCode: string;
    message?: string;
  };
};

export const useStartTrialForFeatureEntitlementMutation = createUseMutationHook<
  Response,
  Variables
>(StartTrialForFeatureEntitlement);
